import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueMarkdown from "vue-markdown";
import VueMoment from "vue-moment";
import Paginate from "vuejs-paginate";
import VueI18n from "vue-i18n";
import VueRouteMiddleware from "vue-route-middleware";
import "./assets/css/responsive.scss";
import "./assets/css/main.scss";
import "./assets/css/main.css";
import "./assets/css/style.min.css";
import i18n from "./i18n";

// Vue.directive("markdown");
Vue.use(VueAxios, axios);
Vue.use(VueMarkdown);
Vue.use(VueMoment);
Vue.use(VueI18n);
Vue.use(VueRouteMiddleware);
Vue.component("paginate", Paginate);

router.beforeEach((to, from, next) => {
  let language = to.params.lang;
  if (!language) {
    language = "mn";
  }

  i18n.locale = language;
  next();
});

new Vue({
  router,
  axios,
  i18n,
  render: h => h(App)
}).$mount("#app");
